<template>
  <v-col style="max-width: 900px">
    <h1 class="primary--text">
      {{ $t('documentation.titles.signatures.title') }}
    </h1>
    <h2 class="primary--text">
      {{ $t('documentation.texts.signatures.signatureSign.title') }}
    </h2>
    <p>{{ $t('documentation.texts.signatures.signatureSign.paragraph1') }}</p>
    <v-img style="width: 100%; max-width: 600px" contain :src="picDetail" />
    <p>{{ $t('documentation.texts.signatures.signatureSign.paragraph2') }}</p>
    <v-img style="width: 100%; max-width: 600px" contain :src="picEnterPIN" />

    <p>{{ $t('documentation.texts.signatures.signatureSign.paragraph3') }}</p>
    <p>{{ $t('documentation.texts.signatures.signatureSign.paragraph4') }}</p>
    <v-img
      style="width: 100%; max-width: 900px"
      contain
      :src="picDocumentSigned"
    />
  </v-col>
</template>

<script>
export default {
  computed: {
    picDetail() {
      return require('@/assets/documentation/signatures/' +
        this.$t('documentation.texts.signatures.signatureSign.picDetail') +
        '.png')
    },
    picEnterPIN() {
      return require('@/assets/documentation/signatures/' +
        this.$t('documentation.texts.signatures.signatureSign.picEnterPIN') +
        '.png')
    },
    picDocumentSigned() {
      return require('@/assets/documentation/signatures/' +
        this.$t(
          'documentation.texts.signatures.signatureSign.picDocumentSigned'
        ) +
        '.png')
    },
  },
  methods: {},
}
</script>

<style>
.custom-link {
  transition: 0.3s;
  cursor: pointer;
}
.custom-link:hover {
  text-decoration: underline;
}
</style>
